<!-- 信息标题列表：标题 -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :to="{path: '/details',query:{id:info.id}}">
    <div class="title">{{info.title.length>titleLength?(info.title.substring(0,titleLength)+'...'):info.title}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock11',
  props: {
    info: {
      type: Object,
      default: {}
    },
    titleLength:{
      type:Number|String,
      default:15
    },
    labelLength:{
      type:Number|String,
      default:28
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:30px;
  width:100%;
  padding:0px 2px 0px 2px;
  margin-bottom:10px;
  border:0px solid #fff;
  background-color: #fff;
  background-size: 120px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  //border:1px solid #eee;
  color:var(--color6);
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block-a .title{
  position:relative;
  height:30px;
  font-size:12px;
  font-weight:500;
  color:#282A2B;
  line-height:30px;
}


</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock11.vue